import React from 'react';
import { Section } from './ui/Section';
import { XCircle, CheckCircle2 } from 'lucide-react';
export function FinalComparison() {
  const rows = [{
    icon: '⏰',
    without: '3-5 horas/semana planificando desde cero',
    with: '10 min/semana. El resto es entrenar.'
  }, {
    icon: '😓',
    without: 'Siempre los mismos ejercicios → los alumnos se aburren',
    with: '50+ WODs distintos → siempre hay algo nuevo'
  }, {
    icon: '💸',
    without: 'Alumnos que abandonan sin saber por qué',
    with: 'Sistema de progresión → retención visible'
  }, {
    icon: '📋',
    without: 'Sin progresión clara de nivel a nivel',
    with: '6 tomos con progresión anual → mejoran y se quedan'
  }, {
    icon: '😨',
    without: 'Alumno con lesión = pánico o improvisación',
    with: 'Elite Coach 360 → adaptación segura y profesional'
  }, {
    icon: '👥',
    without: 'Niveles mezclados = caos de clase',
    with: 'WODs en 3 niveles → todos mejoran juntos'
  }, {
    icon: '📱',
    without: 'Sin sistema de comunicación con alumnos',
    with: 'Checklist y evaluaciones listas + sistema de seguimiento'
  }, {
    icon: '💼',
    without: 'Sin identidad profesional visible',
    with: 'Sistema que justifica cobrar lo que merecés'
  }];
  return <Section bg="dark-800" data-id="element-131">
      <div className="text-center mb-8 md:mb-16" data-id="element-132">
        <h2 className="text-2xl md:text-4xl font-display font-bold text-white mb-3 md:mb-6" data-id="element-133">
          FUNCIONAL & CROSS 360™
        </h2>
        <p className="text-base md:text-xl text-gray-300 max-w-2xl mx-auto mb-3 md:mb-4" data-id="element-134">
          El próximo lunes podés volver a improvisar la clase. <br data-id="element-135" />
          <span className="text-lime-400 font-bold" data-id="element-136">
            O podés entrar al gym con todo resuelto desde hoy.
          </span>
        </p>
        <h3 className="text-xl md:text-2xl font-display font-bold text-white mt-6 md:mt-8" data-id="element-137">
          ¿Cuánto cuesta NO tenerlo?
        </h3>
      </div>

      <div className="max-w-4xl mx-auto bg-dark-900 border border-dark-700 rounded-3xl overflow-hidden" data-id="element-138">
        <div className="grid grid-cols-2 bg-dark-800 border-b border-dark-700" data-id="element-139">
          <div className="p-3 md:p-6 text-center text-gray-400 font-bold uppercase tracking-wider text-[10px] md:text-sm" data-id="element-140">
            SIN FUNCIONAL & CROSS 360
          </div>
          <div className="p-3 md:p-6 text-center text-lime-400 font-bold uppercase tracking-wider text-[10px] md:text-sm bg-lime-500/5" data-id="element-141">
            CON FUNCIONAL & CROSS 360
          </div>
        </div>

        <div className="divide-y divide-dark-700" data-id="element-142">
          {rows.map((row, i) => <div key={i} className="grid grid-cols-2 relative" data-id="element-143">
              <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-6 h-6 md:w-8 md:h-8 bg-dark-800 rounded-full flex items-center justify-center text-xs md:text-sm z-10 border border-dark-700" data-id="element-144">
                {row.icon}
              </div>

              <div className="p-3 md:p-6 pr-5 md:pr-8 flex items-center gap-2 md:gap-3" data-id="element-145">
                <XCircle className="w-4 h-4 md:w-5 md:h-5 text-red-500/70 flex-shrink-0" data-id="element-146" />
                <span className="text-gray-400 text-xs md:text-base" data-id="element-147">
                  {row.without}
                </span>
              </div>

              <div className="p-3 md:p-6 pl-5 md:pl-8 flex items-center gap-2 md:gap-3 bg-lime-500/5" data-id="element-148">
                <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-lime-500 flex-shrink-0" data-id="element-149" />
                <span className="text-white font-medium text-xs md:text-base" data-id="element-150">
                  {row.with}
                </span>
              </div>
            </div>)}
        </div>
      </div>
    </Section>;
}